export function authHeaders(token: string | null, json = false): Record<string, string> {
  return {
    Authorization: `Bearer ${token || ''}`,
    ...(json ? { 'Content-Type': 'application/json' } : {}),
  };
}

export async function ontologyRequest<T>(token: string | null, url: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(url, {
    ...init,
    headers: { ...authHeaders(token, Boolean(init.body)), ...(init.headers || {}) },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || '请求失败，请稍后再试');
  return body as T;
}
